// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudUploadOutlinedSvg from "@fishx/icons-svg/es/asn/CloudUploadOutlined";
import FishxIcon from '../components/FishxIcon';

var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudUploadOutlinedSvg
  }));
};

CloudUploadOutlined.displayName = 'CloudUploadOutlined';
export default React.forwardRef(CloudUploadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudUploadOutlined.js
// module id = 2264
// module chunks = 0